export default [
    {
        path: '/tools/historical-quotes',
        name: 'historical_quotes',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Historical quotes',
        },
        components: {
            default: () => import('@views/tools/HistoricalQuoteIndex.vue'),
        },
    },
    {
        path: '/tools/other-insurance',
        name: 'other_insurance',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Covers with other',
        },
        components: {
            default: () => import('@views/tools/OtherInsuranceIndex.vue'),
        },
    },
];
